/**
 * The HTTP client already strips the outer `{ data }` envelope, but a few endpoints
 * nest the payload once more. Accept both shapes so every consumer of a shared
 * query gets the same value.
 */
export const unwrapData = <T>(response: T | { data: T }): T =>
  (response as { data?: T } | null)?.data ?? (response as T);
